<div class="d-flex align-items-start justify-content-between">
  <p class="text-inherit mb-0">
    <a target="_blank" [href]="file.fileurl" class="text-link" title='Download "{{file.displayname}}"' download><i
        class="fa fa-download mr-2"></i>{{file.displayname}}</a>
  </p>
  <button *ngIf="!confirmDelete && adminuser" (click)="popconfirmdelete(1)"
    class="text-danger bg-transparent border-0 ml-3 px-0 py-1" title="Delete">
    <i class="fas fa-trash-alt"></i>
  </button>
</div>
<div *ngIf="confirmDelete" class="mt-2 mb-4">
  <p class="alert text-center deleteConfirmText">Are you sure you want to delete this file?</p>
  <div class="d-flex justify-content-around flex-wrap gap-.3">
    <button type="button" (click)="deleteconfimed(file.id)" class="btn btn--danger btn--sm text-xs m-0">Yes</button>
    <button type="button" (click)="popconfirmdelete(0)" class="btn btn--sm text-xs m-0">No</button>
  </div>
</div>
